import { primaryColor } from "../colors";
import DateLocationInfo from "../components/DateLocationInfo";
import List from "../components/List";
import Section from "../components/Section";

const ExperienceSection = () => {
    return (
        <Section title="Experience">
            <List>
                <Job
                    title="Co-founder / CEO / CTO"
                    company="Savvy"
                    dates="02/2024 - Present"
                    location="Santa Monica, CA"
                    href="https://trysavvy.co/"
                >
                    <li>
                        Founded and built AI-powered recruiting platform from
                        scratch, leading all aspects of product strategy,
                        engineering execution, and team building to reach 1000+
                        weekly active users and multiple pilot companies.
                    </li>
                    <li>
                        Hired and managed team of 4 (3 engineers, web designer),
                        establishing engineering practices (daily standups,
                        biweekly 1:1s, performance reviews) that enabled team to
                        ship features weekly while maintaining code quality.
                    </li>
                    <li>
                        Architected and scaled microservice network processing
                        ~50K jobs/candidates weekly, building AI-searchable
                        database of 5M+ candidates with automated matching and
                        outreach.
                    </li>
                    <li>
                        Built search and ranking algorithms from scratch,
                        implementing relevance scoring, query understanding, and
                        semantic matching using LLMs to optimize candidate
                        discovery.
                    </li>
                    <li>
                        Designed and built ML-based recommendation system for
                        job-candidate matching, with continuous feedback loops
                        to improve ranking quality.
                    </li>
                    {/* <li>
                        Established tight customer feedback loops with pilot
                        companies, incorporating insights into sprint planning
                        to rapidly ship requested features and improvements.
                    </li>
                    <li>
                        Developed business strategy and executed go-to-market
                        approach, translating technical architecture into market
                        positioning for startups/SMBs.
                    </li> */}
                    {/* <li>
                        Led technical architecture decisions (React, NextJS,
                        PostgreSQL, AWS), establishing reusable components that
                        accelerated development while maintaining 99.9% uptime.
                    </li> */}
                </Job>
                <Job
                    title="Software Engineer - Simulations & Optimization"
                    company="Areté"
                    dates="08/2021 - 08/2023"
                    location="Los Angeles, CA"
                    href="https://www.arete.com/"
                >
                    <li>
                        Led team of 3 engineers through complete product
                        overhaul, migrating legacy Fortran codebase to
                        GPU-optimized C++/CUDA, reducing simulation runtime by
                        10-20x and integrating the results into the production
                        system.
                    </li>
                    <li>
                        Integrated offline neural network models into the live
                        C++ system using TensorFlow's C API and built the
                        validation infrastructure to ensure models ran correctly
                        and at speed in production.
                    </li>
                    {/* <li>
                        Identified gaps in team development and created
                        mentorship program for junior engineers on classified
                        project, establishing onboarding processes and technical
                        training that became standard practice.
                    </li> */}
                    <li>
                        Optimized simulation algorithms by reducing space
                        complexity from quadratic to linear and building a
                        dynamic programming approach that generalized the
                        expansion order beyond its previous hardcoded limit
                        (previously limited to order 4), enabling arbitrarily
                        precise simulations without exploding in time or space.
                    </li>
                    <li>
                        Selected as technical lead for simulation products
                        requiring deep physics domain knowledge, serving as
                        primary liaison between research and engineering teams
                        and presenting technical approach and results to DoD
                        stakeholders.
                    </li>
                    <li>
                        Built internal developer tools and contributed to the
                        customer-facing frontend for accessing and configuring
                        data collection runs.
                    </li>
                    <li>
                        Systems operated on distributed job queues processing
                        radar and satellite imagery data at petabyte scale.
                    </li>
                </Job>
            </List>
        </Section>
    );
};

export const ExperienceContinuedSection = () => {
    return (
        <Section title="Experience (continued)">
            <List>
                <Job
                    title="Lead Software Engineer - New Product Initiative"
                    company="Radical Semiconductor"
                    dates="08/2023 - 01/2024"
                    location="Pasadena, CA"
                    href="https://www.linkedin.com/company/radical-semiconductor/"
                >
                    <li>
                        Hired as technical lead for new product initiative,
                        driving direction for team of 2 engineers and rapidly
                        shipping customer-ready products in 2-week sprint
                        cycles.
                    </li>
                    <li>
                        Quickly ramped on specialized technology stack (Java
                        Card, NFC protocols, OAuth integration, smart contracts)
                        to establish technical direction for crypto hardware
                        wallet ecosystem.
                    </li>
                    <li>
                        Delivered 3 interconnected products from concept to
                        customer deployment in under 6 months: hardware wallet
                        (LiteCard), mobile NFC application, and web-based
                        distributor management platform.
                    </li>
                    <li>
                        Collaborated with founding team on product strategy and
                        technical priorities, balancing aggressive timelines
                        with hardware constraints and user experience
                        requirements.
                    </li>
                </Job>
                <Job
                    title="Co-founder / CTO"
                    company="Bazar"
                    location="Los Angeles, CA"
                    dates="11/2020 - 08/2023"
                    href="https://bazar.earth/"
                >
                    <li>
                        Co-founded mobile e-commerce SaaS platform, leading
                        technical strategy and engineering execution from
                        concept to 10,000+ downloads across iOS and Android.
                    </li>
                    <li>
                        Hired, managed, and mentored engineering team of 5,
                        establishing development processes (standups, 1:1s, code
                        reviews) that enabled rapid feature delivery while
                        maintaining team culture and code quality, including
                        shipping complex features like in-app chat and
                        bargaining system in under one month from start to
                        deployment.
                    </li>
                    <li>
                        Built search and filtering system across tens of
                        thousands of products, implementing ranking algorithms
                        that balanced recency, relevance, and popularity for
                        product discovery.
                    </li>
                    <li>
                        Architected scalable e-commerce platform with ML-powered
                        recommendations, making key technical decisions on stack
                        and infrastructure (React Native, Django, PostgreSQL,
                        AWS).
                    </li>
                    <li>
                        Designed novel seed-random home page pagination system
                        that balanced recency, relevance, and popularity for
                        infinite-scroll discovery, driving user engagement
                        across product catalog.
                    </li>
                    <li>
                        Implemented comprehensive caching strategy (local +
                        backend) that transformed app performance from sluggish
                        to lightning-fast response times, significantly
                        improving user experience.
                    </li>
                    <li>
                        Owned all technical decision-making as CTO, partnering
                        with co-founder on product strategy through multiple
                        pivots while translating customer needs into engineering
                        priorities.
                    </li>
                </Job>
                <Job
                    title="Software Engineer - Verification"
                    company="Abbott"
                    dates="01/2021 - 08/2021"
                    location="Los Angeles, CA"
                    href="https://www.abbott.com/"
                >
                    <li>
                        Developed automated testing for FDA-regulated medical
                        devices; gained experience with enterprise-scale
                        development processes before transitioning to more
                        product-focused roles with greater technical ownership
                        and direct impact.
                    </li>
                </Job>
                {/* <Job
                    title="Software Engineer Intern"
                    company="Automated Living"
                    dates="05/2020 - 08/2020"
                    location="Los Angeles, CA"
                    achievements={[
                        "Prototyped IOT products using Raspberry Pi's, utilizing LoRaWAN as well as 4G Modem technologies",
                        "Spearheaded backend and database messaging using MQTT",
                    ]}
                /> */}
                {/* <Job
                    title="Physics & Mathematics Tutor"
                    company="LMU College of Science & Engineering"
                    dates="08/2017 - 12/2019"
                    location="Los Angeles, CA"
                    href="https://cse.lmu.edu/"
                >
                    <li>
                        Provided weekly tutoring for upper and lower-division
                        students enrolled in a variety of different Mathematics
                        & Physics courses.
                    </li>
                    <li>
                        Improved grades of students as well as deepened their
                        understanding of the topics at hand, with several
                        positive testimonies from professors.
                    </li>
                </Job> */}
                {/* <Job
                    title="Technical Assistant"
                    company="Pixelgate Networks"
                    dates="05/2015 - 08/2016"
                    location="Los Angeles, CA"
                    achievements={[
                        "Organized company's server facility to optimize process improvement and minimize supply costs",
                        "Built and performed maintenance on servers to establish internet security systems and optimize power supplies",
                        "Worked on technical projects to improve computing performance"
                    ]}
                /> */}
            </List>
        </Section>
    );
};

export const Job = ({ title, company, dates, location, href, children }) => {
    return (
        <div>
            <a href={href}>
                <h3>{title}</h3>
                <h4 style={{ color: primaryColor }}>{company}</h4>
            </a>
            <DateLocationInfo dates={dates} location={location} />
            <ul>{children}</ul>
        </div>
    );
};

export default ExperienceSection;
